<p>ticket-follow-on-dialog works!</p>
